import React, { useState } from 'react'
import { Collapse } from 'react-bootstrap'

export const CollapsableContainer = ({ title, children, count }) => {
  const [open, setOpen] = useState(true)
  const chevronClass = open ? 'fa fa-chevron-down' : 'fa fa-chevron-right'
  const borderRadius = open ? '10px 10px 0 0' : '10px 10px 10px 10px'
  const alertClass = count && count > 0 ? 'label label-info-data' : 'label label-info'
  return (
    <>
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div
          style={{ cursor: 'pointer', borderRadius }}
          className={'ibox-title round-corner-box-top'}
          onClick={() => setOpen(!open)}
        >
          <i style={{ width: '10px' }} className={chevronClass} />
          <header>{title}</header>
          {count && (
            <div className={alertClass} style={{ float: 'right' }}>
              {count}
            </div>
          )}
        </div>
        <Collapse in={open}>
          <div className='ibox-content round-corner-box-bottom'>{children}</div>
        </Collapse>
      </div>
    </>
  )
}
